import { render, staticRenderFns } from "./b-approved.vue?vue&type=template&id=ff188f32&"
import script from "./b-approved.vue?vue&type=script&lang=js&"
export * from "./b-approved.vue?vue&type=script&lang=js&"
import style0 from "./b-approved.vue?vue&type=style&index=0&id=ff188f32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports